import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ModalXacNhanGiaoTien } from "./ModalXacNhanGiaoTien";

export const BtnXacNhanGiaoTien = ({ item }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a onClick={handleShow} href={() => false}>
        <PopoversBootrap
          contentText="Xác nhận giao tiền"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
          <i className="fas fa-hand-holding-usd" style={{scale:"80%"}}></i>
        </PopoversBootrap>
      </a>

      {show && (
        <ModalXacNhanGiaoTien
          show={show}
          onHide={handleClose}
          chovayId={item.ChoVayId}
          item={item}
        />
      )}
    </>
  );
};
